module.exports = __webpack_public_path__ + "img/kehu_hengxinjituan.d1b8861d.png";